module.exports = __webpack_public_path__ + "static/media/use09.1deffde6.png";